export function asWebComponent(superclass) {
  class HtmlMixin extends superclass {
    constructor() {
        super()
        this.shadow = this.attachShadow({ mode: "open" })
        this.init()
        this._rendered = false
    }

    /**
     * Called when your component is attached to the DOM.
     * By default, this calls the render() method, You should 
     * not normally need to override this.
     */
    connectedCallback() {
        // workaround for Ionic calling connectedCallback multiple times
        if (!this._rendered) {
          this.render()
          this._rendered = true
        }
    }

    /**
     * Initialize and reset your state. The default reset() method
     * uses this to reset the state and re-render your component.
     */
    init() { }

    /**
     * Render the component. You can create a DOM tree and attach 
     * it to the `shadow` property, or set the HTML string into 
     * the `shadow.innerHTML` property.
     */
    render() { }

    /**
     * Reset the component. By default, calls `init()` and `render()`.
     */
    reset() {
        this.init()
        this.render()
    }

    /**
     * Update the component's UI with the current state. Call this 
     * method after making state changes. By default, it calls the 
     * `render()` method, but you can override this to do more efficient
     * updates, since `render()` will tear down and re-create the component DOM
     */
    update() {
        this.render()
    }
  }

  return HtmlMixin;
}

export default class WebComponent extends asWebComponent(HTMLElement) {
} 

